<template>
  <div :class="{ 'visible' : visible, 'invisible' : !visible }">
    <div class="fixed top-0 left-0 w-full h-full z-20 bg-gray-800 opacity-50" v-on:click="toggleNotepad()"></div>
    <div class="fixed top-0 right-0 h-full z-30 bg-white" 
      style="width:600px;">

      <div class="absolute w-full" 
        style="height: calc(100% - 0px);overflow-y: auto;">
        
        <div class="">
          <div class="flex items-center justify-between p-4 bg-gray-200">
            <div class="flex items-center">
              <div class="text-sm text-gray-600 font-semibold">Notepad</div>
              <!-- <span class="mx-2 text-gray-400">/</span>
              <a href="#" class="text-gray-600 hover:underline" @click.prevent="orderBy('created_at')">Sort by created date</a>
              <span class="mx-2 text-gray-400">/</span>
              <a href="#" class="text-gray-600 hover:underline" @click.prevent="orderBy('created_at')">Last updated</a> -->
            </div>

            <a href="#"
              @click.prevent="toggleNotepad()"
              class="text-gray-500 hover:text-gray-700">
              <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
              </svg>
            </a>
          </div>

          <template v-for="(note, index) in notes">
            <div class="p-4">
              <div class="flex items-center">
                <div class="text-base">{{ note.page.charAt(0).toUpperCase() + note.page.substring(1) }}</div>
              </div>

              <div class="mt-2">
                <textarea
                  class="w-full border border-gray-600 text-sm outline-none rounded p-3 focus:bg-yellow-200"
                  :ref="note.page"
                  style="height:100px;"
                  :value="note.value"
                  v-on:blur="saveNote({
                    page : note.page,
                    value: $event.target.value,
                    index: index
                  })" />
              </div>
            </div>
          </template>
        </div>

        <div class="mt-8 px-4">
          <a href="#" @click.prevent="toggleNotepad()" 
            class="bg-gray-600 text-white text-xs font-semibold hover:bg-gray-700 px-8 py-3 rounded-sm">Close</a>
        </div>
        <br/>
        <br/>
      </div>    
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus'
  
  export default {
    
    data() {
      return {
        notes   : null,
        page: null,
        visible : false
      }
    },

    created() {
      this.setNotes()
    },

    mounted() {
      EventBus.$on('toggle-notepad', (params) => {
        if(params != null && params.page != null) {
          this.page = params.page
        }

        this.visible = !this.visible

        if(this.visible) {
          this.$nextTick(() => {
            if(this.$refs[this.page] != null && this.$refs[this.page][0] != null) {
              this.$refs[this.page][0].focus()
            } 

            else {
              // console.log(this.$refs['requirements'])
              this.$refs[this.page].focus()
            }
          })
        }
      })
    },

    beforeDestroy() {
      EventBus.$off('toggle-notepad')
    },

    methods : {

      saveNotes() {
        this.apiPost({
          clientId: this.$route.params.clientId,
          notes   : this.notes,
        }, 'client/notes', (notes) => {
          this.$store.commit(this.$store.state.view + "Module/setNotes", notes)
        })
      },

      setNotes() {
        if(this.$store.state[this.$store.state.view + 'Module'].client.notes != null) {
          var n = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].client.notes)
          if(n.data != null) {
            this.notes = JSON.parse(n.data)
          }

          // // make sure that the current page exists
          // let exists = false;
          // for(let i=0; i < this.notes.length; i++) {
          //   if(this.notes[i].page == this.page) {
          //     exists = true
          //   }
          // }

          // if(!exists) {
          //   this.notes[]
          // }
        }

        else {
          this.notes = [{
            page : 'applicants',
            value: null
          }, {
            page : 'requirements',
            value: null
          }, {
            page : 'assets',
            value: null
          }, {
            page : 'liabilities',
            value: null
          }, {
            page : 'living expenses',
            value: null
          }, {
            page : 'risk profile',
            value: null
          }, {
            page : 'documents',
            value: null
          }, {
            page : 'submit', 
            value: null
          }, {
            page : 'others',
            value: null
          }]
        }
      },

      // deleteNote(index) {
      //   if(this.notes[index].page == this.pageItem.page && this.notes[index].item == this.pageItem.item) {
      //     this.pageItem.deleted = true
      //   }

      //   this.notes.splice(index, 1)
      //   this.saveNotes()
      //   // this.apiDelete({
      //   //   clientId: this.$route.params.clientId,
      //   //   index   : index,
      //   // }, 'client/note', (notes) => {
      //   //   this.$store.commit(this.$store.state.view + "Module/setNotes", notes)
      //   //   this.setNotes()
      //   // })
      // },

      saveNote(params) {
        if(params.value != null && params.value.length > 0 && this.notes[params.index].value != params.value) {
          this.notes[params.index].value = params.value
          this.saveNotes()
          // this.apiPost({
          //   clientId: this.$route.params.clientId,
          //   page    : params.page,
          //   item    : params.item,
          //   label   : params.label,
          //   value   : params.value
          // }, 'client/note', (notes) => {
          //   this.$store.commit(this.$store.state.view + "Module/setNotes", notes)
          //   this.setNotes()
          // })
        }
      }
    }
  }
</script>